import Tree from './Tree';
import TreeNode from './TreeNode';

Tree.TreeNode = TreeNode;

export { TreeNode };
export default Tree;


//////////////////
// WEBPACK FOOTER
// ./~/rc-tree/es/index.js
// module id = 1582
// module chunks = 3